import Command from './command';
import CommandResult from './command-result';
import { classForType } from '@intercom/embercom-composer/blocks/types/base/block';
import ReturnCommand from './return';
import BackspaceCommand from './backspace';
import Em from 'ember';
export default Command.extend({
  processZeroWidth() {
    let specifiedIndex = this.get('options.index');
    if (Em.isPresent(specifiedIndex)) {
      return this._doInsert(specifiedIndex);
    }
    if (this.get('firstSelectedBlock.isListType')) {
      return this._insertAfterFirstSelectedBlock();
    }
    let insertAt = this.get('selection.startBlockIndex');
    if (this.get('selection.isNotAtStartOfBlock')) {
      this._doReturn();
      insertAt++;
    }
    return this._doInsert(insertAt);
  },
  processSingleBlock() {
    this._doBackspace();
    let isAtEnd = this.get('selection.endPositionIndex') === this.get('firstSelectedBlock.text.length');
    if (!this.get('isFirstSelectedBlockCovered') && !this.get('selection.isAtStartOfBlock') && !isAtEnd) {
      this._doReturn();
    }
    this.snapshotState();
    if (this.get('isFirstSelectedBlockCovered')) {
      this.removeFirstSelectedBlock();
    }
    if (this.get('firstSelectedBlock.isListType')) {
      return this._insertAfterFirstSelectedBlock();
    }
    let insertPoint = this.get('selection.startBlockIndex');
    if (isAtEnd) {
      insertPoint++;
    }
    return this._doInsert(insertPoint);
  },
  processMultiBlock() {
    if (this.get('firstSelectedBlock.isListType')) {
      return this._insertAfterFirstSelectedBlock();
    }
    this._doReturn();
    this.snapshotState();
    this.removeFirstSelectedBlock();
    return this._doInsert(this.get('selection.startBlockIndex'));
  },
  _insertAfterFirstSelectedBlock() {
    let index = this.get('selection.startBlockIndex') + 1;
    return this._doInsert(index);
  },
  _doInsert(index) {
    let newBlock = this.get('options.block');
    this.insertBlock(newBlock, index);
    this._setSelection(newBlock, index);
    return CommandResult.create({
      newBlock
    });
  },
  _setSelection(newBlock, index) {
    if (this.get('options.selectNewBlock')) {
      this.setSelectionToStartOf(newBlock);
    } else if (this.get('blockList').objectAt(index + 1)) {
      this.setSelectionToBlockAfter(newBlock);
    } else {
      this.setSelectionToStartOf(this.insertDefaultBlock(index + 1));
    }
  },
  _doReturn() {
    return ReturnCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      options: {
        forceSplit: true
      },
      config: this.get('config')
    }).run();
  },
  _doBackspace() {
    return BackspaceCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      config: this.get('config')
    }).run();
  },
  _getNewBlock() {
    let options = this.get('options');
    options.config = this.get('config');
    return classForType(options.blockType).create(options);
  }
});